import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import moment from 'moment';

import { ReduxPlex } from '../models/ReduxPlex';

export const toTitleCase = (input?: string): string => {
  if (!input) {
    return '';
  }
  return input.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const formatDisplayedDate = (d: Date): string => {
  // format taken from github issues: https://github.com/facebook/react/issues/10
  if (new Date().getTime() - d.getTime() < 28 * 24 * 60 * 60 * 1e3) {
    return moment(d).fromNow();
  } else {
    return moment(d).format('DD MMM YYYY');
  }
};

export const formatFullDate = (d: Date): string => {
  return moment(d).toLocaleString();
};

export const getPlexesOrder = (plexes: ReduxPlex[]): { [plexId: string]: number } => {
  const order: { [plexId: string]: number } = {};
  let latestIndex = 0;
  plexes
    .filter((p) => p.currentUserRelation.state !== PlexUserRelationState.Subscriber)
    .forEach((p, index) => {
      order[p.id] = index;
      latestIndex = index;
    });
  plexes
    .filter((p) => p.currentUserRelation.state === PlexUserRelationState.Subscriber)
    .forEach((p, index) => {
      order[p.id] = index + latestIndex + 1;
    });
  return order;
};
